// src/__mapStateToProps.ts
import { createMapStateToProps, mergeProps } from "@vf-djr/utilities";
var mapStateToPropsPlugin = ({ __mapStateToProps }, Element, { ReactReduxContext, selectors = {}, connect } = {}) => {
  if (!connect) {
    console.error("Missing the 'connect' initialisation property for the Map State To Props plugin");
    return Element;
  }
  if (!__mapStateToProps) {
    return Element;
  }
  const mapStateToProps = createMapStateToProps(selectors)(__mapStateToProps);
  return connect(mapStateToProps, {}, mergeProps, {
    context: ReactReduxContext
  })(Element);
};
var mapStateToProps_default = mapStateToPropsPlugin;

// src/index.ts
var src_default = mapStateToProps_default;
export {
  src_default as default
};
